import ANGSearch from './ANGSearch.container';

export default ANGSearch;
